import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import Main from 'components/main';
import ArticleBody from 'components/article-body';
import css from 'static/style/dow.less';
import fontAwesome from 'rlink-lesscore/icons/font-awesome.less';
import {Picture} from 'rlink-repos/content-components';
import {ArticleComponent} from 'rlink-blog/component';
import {FacebookShare, TwitterShare} from 'rlink-social-share/component';
import {DOW} from 'terms';
import DocumentTitle from 'rlink-react-document/DocumentTitle.jsx';
import DocumentOpenGraphProperty from 'rlink-react-document/DocumentOpenGraphProperty.jsx';

export default function (params, content) {
  let defaultName = <FormattedMessage
    id="ui.label.title.DEFAULT_ARTICLE_TITLE"
    defaultMessage="article"
    description="Default title for a news article" />;

  let title = (content) ? content.article.data.get('title') : defaultName;
  let dataFormatted = content.article.data.toJS();
  return (<Main globalSettings={content.globalSettings}>
    <DocumentTitle title={title} site={DOW} />
    <DocumentOpenGraphProperty property="url" value={`https://www.dawnofwar.com/${params.slug}`} />
    <DocumentOpenGraphProperty property="title" value={title} />
    <DocumentOpenGraphProperty property="description" value={dataFormatted.introduction} />
    <DocumentOpenGraphProperty property="image" value={dataFormatted.bannerPath} />
    <div key={`article:${title}`}>
      <section className={`${css['content-panel']} ${css['article-full']}`}>
        <article className={css['panel-content']}>
          <Header slug={params.slug}
            title={content.article.data.get('title')}
            authorName={content.article.data.get('author').get('name')}
            forumsProfile={content.article.data.get('author').get('forumsProfile')}
            publishedOn={content.article.data.get('publishedOn')} />
          <main>
            <h1>{content.article.data.get('title')}</h1>
            <div className={css['article-intro']}>
              {content.article.data.get('introduction')}
            </div>
            <Picture
              className={css['article-cover']}
              src={dataFormatted.bannerImageFormats.src}
              widths={dataFormatted.bannerImageFormats.widths}
              heights={dataFormatted.bannerImageFormats.heights}
              formats={dataFormatted.bannerImageFormats.formats} />

            <ArticleBody bodyHtml={content.article.data.get('body')} />

          </main>

        </article>

      </section>
    </div>

  </Main>);
}

class Header extends ArticleComponent {
  render () {
    return (<header>
      <div className={css['article-meta']}>
        <FormattedMessage
          id="ui.text.info.ARTICLE_META"
          defaultMessage="by {AUTHOR} on {DATE}"
          description="Caption next to a news article."
          values={{
            AUTHOR: <a target="_blank" rel="noopener noreferrer" href={this.props.forumsProfile}>{this.props.authorName}</a>,
            DATE: this.formatDate(this.props.publishedOn),
          }} />
      </div>
      <div className={css['article-share']}>
        <span>
          <FormattedMessage
            id="ui.label.title.FACTION_SHARE"
            defaultMessage="share"
            description="Heading for the share section on the news article page." />
        </span>
        <ul className={css['social-links']}>
          <FacebookShare
            fontAwesome={fontAwesome}
            css={css}
            shareUrl={`${(typeof window.location !== 'undefined') ? window.location.origin : ''}/article/${this.props.slug}`}
            shareText={this.props.title} />
          <TwitterShare
            fontAwesome={fontAwesome}
            css={css}
            shareUrl={`${(typeof window.location !== 'undefined') ? window.location.origin : ''}/article/${this.props.slug}`}
            shareText={this.props.title} />
        </ul>
      </div>
    </header>);
  }
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/views/article.jsx